import { partitionByGUIDURL } from '../../../NonReact/constants/ApiConstants'
import { IsStringEmpty } from '../../../NonReact/utils/GlobalFunctions'
import { DEFAULT_CME_ID } from '../../AddUser/Constants'
import { ALL_VALUE, getTelephonyServer } from './ItemsGetters'
import { requestGetJSON } from '../../../NonReact/common/API/REST/RESTAPIClient'
import { APIData, JSONResponse } from '../../../NonReact/common/Types/Types'
import { IndividualTelItem, Partition } from '../Types/Types'
import { getCME } from '../../../NonReact/common/API/EntityAPIClient'

const CACHE_TIME: number = 10000

const DEFAULT_PARTITION: string = '73e4b32acf5b3b94:-6b17d22d:117408ebd2b:-7c1a'

// Get partInTelSysID from the partitionGUID.
export const getPartitionInTelSysFromGUID = (partitionGUID?: string): Promise<Definable<number>> => {
    if (IsStringEmpty(partitionGUID) || partitionGUID === DEFAULT_PARTITION) {
        return Promise.resolve(ALL_VALUE)
    }

    return requestGetJSON<APIData<Partition>>(partitionByGUIDURL(partitionGUID), {
        cacheTime: CACHE_TIME
    })
        .then(
            (partitionData: JSONResponse<APIData<Partition>>): Definable<number> =>
                partitionData?.Data?.PartIDInTelSys ?? undefined
        )
        .catch((): Definable<number> => undefined)
}

// Get CME ID from tel sys.
export const getCMEIDFromTelSys = (telSysID?: number | string, currentCMEID?: string): Promise<Definable<string>> => {
    if (!telSysID || telSysID === ALL_VALUE) {
        return Promise.resolve(currentCMEID ?? DEFAULT_CME_ID)
    }

    return getTelephonyServer(telSysID)
        .then((telServer: Nullable<IndividualTelItem>): Definable<string> => {
            if (telServer && !IsStringEmpty(telServer.CMEnvironmentID)) {
                return telServer.CMEnvironmentID
            }

            return currentCMEID
        })
        .catch((): Definable<string> => currentCMEID)
}

export const getCapabilitiesFromCME = (cmeId: string): Promise<Definable<number>> =>
    getCME(cmeId).then((cme): Definable<number> => cme?.Capabilities)
